import { Outlet } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import ScrollToTop from './ScrollToTop';
import CookieBanner from './CookieBanner';

const SiteLayout = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1 pt-[7.5rem]">
        <Outlet />
      </main>
      <SiteFooter />
      <CookieBanner />

      {showScroll && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-20 right-6 z-50 w-10 h-10 rounded-lg bg-primary text-primary-foreground flex items-center justify-center hover:bg-primary/90 transition-colors shadow-lg"
          aria-label="Retour en haut"
        >
          <ChevronUp size={18} />
        </button>
      )}
    </div>
  );
};

export default SiteLayout;
